import { useEffect, useState } from 'react';
import { appendStyleSheet, getEndpoint, getUrl, fetchAnchorValue} from '../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import "./FourLinks.css";
import Link from '@mui/material/Link';
import bcrypt from 'bcryptjs-react';

FourLinks.version = 1000;

FourLinks.lang = 'en';
FourLinks.langs = [
   'en'
];
FourLinks.setLang = (lang: any) => {
   FourLinks.lang = lang;
}

Object.defineProperty(FourLinks, 'name', {
   writable: true,
   value: 'FourLinks'
});





export function FourLinks(props: any) {

   const { anchorLinksValue } = props;

   let styles = require("./FourLinks.css");
   const [msid, setMsid] = useState<any>('');
   const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
   const {TextColor, BgColor } = props


   appendStyleSheet("FourLinks", styles);
   const endpoint = getEndpoint(props);
   useEffect(() => {
      if (!endpoint.isSSR || !endpoint.SSRDataObj) {
         fetchComponentData();
      }
   }, [props.MSID, endpoint, props.showAdSlot]);

   const setItemsObj = (response: any) => {
      setItems(response.items)
   }

   if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length)
      && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
      setItemsObj(endpoint.SSRDataObj);
   }

   const fetchComponentData = () => {
      getData(getUrl(props));
   }

   const getData = (url: string) => {
      let headerString = '?' + url.split("?")[1];
      headerString = bcrypt.hashSync(headerString, 6);
      const headers = { 'p-nonce': headerString };

      fetch(url, { headers: headers })
         .then((response) => response.json())
         .then(response => {
            setItemsObj(response);
         })
         .catch(err => {
            //console.log(err);
         });
   }
   const truncateToWords = (text: string, wordCount: number) => {
      const words = text.split(' ');
      if (words.length <= wordCount) return text;
      return words.slice(0, wordCount).join(' ') + '...';
    };

   const getRenderPart = () => {
      if (msid && props.msid && msid != props.msid) {
         props.queryParams.msid = props.msid;
         setMsid(props.queryParams.msid);
         getData(getUrl(props));
      }

      if (!items || !items.length) {
         return "";
      }

      return (
         <div className='FourLinksMainWrapper'>
            {items.length > 0 && items.map((val, index) =>
               <Link href={val?.wu} className='FourLinksWrapper' target={fetchAnchorValue(anchorLinksValue, val?.wu)}  style={{backgroundColor:BgColor}}>
                  <p className='FourLinksHeading' style={{color:TextColor}}>{truncateToWords(val.hl ?? '', 3)}</p>
                  <p className='FourLinksSubHeading' style={{color:TextColor}}>{truncateToWords(val.syn ?? '', 6)}</p>
               </Link>
            )


            }

         </div>
      );
   }

   return (
      <>
         {getRenderPart()}
      </>
   );

}




















